import React from "react";
import { connect } from "react-redux";
import { withStat } from "redux/selectors";
import SiteStat from "components/SiteStat";
import { compose, propEq, find } from "ramda";

const Site = props => (
  <div className="statistic-table">
    <SiteStat {...props.list} {...props} isSingle={true} />
  </div>
);

const mapStateToProps = (state, ownProps) => {
  const { stat: { type: { total: { main: { isFetching, errors } } } } } = state;
  const { match: { params: { publisherID: site_id } } } = ownProps;

  const current = compose(find(propEq("id", +site_id)), withStat)(state);
  return {
    errors,
    ...current,
    isFetching
  };
};

export default connect(mapStateToProps)(Site);
